import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { archiveStoryHome, deleteStoryHome, unArchiveStoryHome } from '../../../actions/userActions'
import { CloseIcon, NextIcon } from '../../../assets/icons'
import inMemoryJwt from '../../../auth/inMemoryJwt'
import { urlServer } from '../../../config/GlobalConstant'
import { Translate } from '../../../language'
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription'
import Options from '../../../utils/components/Options/Options'
import ChatInput from '../../Chat/ChatInput'
import styles from './StoriesBarNew.module.css'


const StoriesBarNew = ({
    setIsShowStories,
    storyData,
    currenStoryView,
    currenSubStory,
    setCurrenSubStory
}) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [isShowResponse, setIsShowResponse] = useState(false)
    const [seconds, setSeconds] = useState(0)
    const [timeStart, setTimeStart] = useState(0)
    const progressBar = useRef();
    const videoRef = useRef()
    const animationRef = useRef();

    const calcClickedTime = (e) => {
        const clickPositionInPage = e.pageX;
        const bar = progressBar.current;
        const barStart = bar.getBoundingClientRect().left + window.scrollX;
        const barWidth = bar.offsetWidth;
        const clickPositionInBar = clickPositionInPage - barStart;
        const timePerPixel = 100 / barWidth;
        return timePerPixel * clickPositionInBar;
    }


    var counter = () => { }
    const whilePlaying = () => {
        if (videoRef && videoRef.current) {

            setSeconds((parseInt(videoRef.current.currentTime * 10) * 100 / parseInt(videoRef.current.duration * 10)))
            animationRef.current = requestAnimationFrame(whilePlaying);
            if ((parseInt(videoRef.current.currentTime * 10) * 100 / parseInt(videoRef.current.duration * 10)) === 100) {
                if (storyData[currenStoryView][currenSubStory + 1]) {
                    setCurrenSubStory(prevState => prevState + 1)
                }
            }
        }

    }
    useEffect(() => {
        clearInterval(counter)
        console.log("sss");
        if (storyData[currenStoryView][currenSubStory].type === "image") {

            count(parseInt(timeStart))
        }
        if (storyData[currenStoryView][currenSubStory].type === "video") {
            setTimeStart(0)
            setSeconds(0)
            animationRef.current = requestAnimationFrame(whilePlaying)
        }

        return () => {
            //setTimeStart(0)

            clearInterval(counter)

        }
    }, [timeStart, currenSubStory])
    useEffect(() => {
        setTimeStart(0)


        return () => {

        }
    }, [currenSubStory])

    const count = (start) => {

        let secondsTemp = start;


        counter = setInterval(() => {
            if (secondsTemp < 100) {
                secondsTemp = secondsTemp + 1

                setSeconds(secondsTemp)
            } else {
                if (storyData[currenStoryView][currenSubStory + 1]) {
                    setCurrenSubStory(prevState => prevState + 1)
                }
                clearInterval(counter)
            }

        }, 100)
    }


    function handleTimeDrag(e) {
        // audioPlayer.current.currentTime = calcClickedTime(e);
        const updateTimeOnMove = eMove => {
            //   audioPlayer.current.currentTime = calcClickedTime(eMove);
            clearInterval(counter)

            setSeconds(calcClickedTime(eMove))
            setTimeStart(calcClickedTime(eMove))

        };

        document.addEventListener("mousemove", updateTimeOnMove);

        document.addEventListener("mouseup", () => {
            document.removeEventListener("mousemove", updateTimeOnMove);
        });
        //   animationRef.current = requestAnimationFrame(whilePlaying)
    }

    const handleNewUserMessage = async (dataFiles, sendMessage, clear) => {
        //  setLoading(true);

        const formData = new FormData();
        formData.append('storyID', storyData[currenStoryView][currenSubStory].id)


        formData.append('content', `${sendMessage}`)
        formData.append('addresseeID', storyData[currenStoryView][currenSubStory].user._id)
        /*// 
         //formData.append('senderID', idUser)
         if (dataResponsStory)
             
         
         //formData.append('stateMessage', 1)
         formData.append('link', linkGifOrStiker)
         console.log(); */
        await fetch(`${urlServer}chats/send-message`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                //'Access-Control-Allow-Origin': '*'
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `bearer ${inMemoryJwt.getToken()}`
            },
            body: formData
        })
            .then(response => response.json())
            .then(respJson => {

                // console.log()
                // socketLogic.setSocketId("hola")

                //   scroolToBottom()
                history.push({
                    pathname: "/Messages",
                    state: {
                        dataUser: storyData[currenStoryView][currenSubStory].user
                    }
                })

                clear()

            })
            .catch(error => {

                console.log()
            })
        // Now send the message throught the backend API */
    }
    if (!storyData[currenStoryView]) {
        return <></>
    }
    return (
        <div className={styles.show_stories}>
            <div className={styles.close_container}>
                <div onClick={()=>{
                    setIsShowStories(false)
                }}>
                    <CloseIcon className={styles.close_icon} height={23} />
                </div>
            </div>
            <div className={`${styles.story_item} ${styles.story_item_prev} ${!storyData[currenStoryView][currenSubStory - 1] ? styles.story_item_none : ''}`}>

                {
                    storyData[currenStoryView][currenSubStory - 1] && (
                        <>
                            <div className={styles.story_item_content}>


                                {
                                    storyData[currenStoryView][currenSubStory - 1].type === "video" && <img width="100%" src={storyData[currenStoryView][currenSubStory - 1].urlThumb} />
                                }

                                {
                                    storyData[currenStoryView][currenSubStory - 1].type === "image" && <img width="100%" src={storyData[currenStoryView][currenSubStory - 1].url} />
                                }
                            </div>
                        </>
                    )
                }

            </div>
            <div>
                <NextIcon className="cls-back-next back-svg" height="25" width="25"
                    onClick={() => {
                        if (storyData[currenStoryView][currenSubStory - 1]) {
                            setCurrenSubStory(prevState => prevState - 1)
                            // setIsShowResponse(false)

                        }

                    }} />
            </div>

            <div className={styles.story_item}>

                <div>
                    {/*   <input
                        className={styles.bar_progress}
                        type="range" min="1" step={1} max="100" value={seconds} onChange={(e) => {
                           clearInterval(counter)
                        
                           setSeconds(e.target.value)
                            setTimeStart(e.target.value)
                          //  console.log(e.target.value);
                           /// count(e.target.value)
                          
                             }} /> */}
                    <div
                        ref={progressBar}
                        className={styles.bar_progress}
                        style={{
                            background: `linear-gradient(to right, var(--primary-color-dark) ${seconds}%, var(--secondary-color) 0)`
                        }}
                        onMouseDown={e => {
                            if (storyData[currenStoryView][currenSubStory].type === "image") {
                                handleTimeDrag(e)
                            }

                        }}
                    >

                    </div>
                    <div className={styles.story_item_opt}>






                        <ImageNameDescription
                            srcImage={storyData[currenStoryView][currenSubStory].header.profileImage}
                            firstName={storyData[currenStoryView][currenSubStory].header.heading}
                            secondName={storyData[currenStoryView][currenSubStory].header.headingLast}
                        />

                        <Options style={{
                            position: 'relative',
                            marginLeft: "auto"
                        }}
                            options={[
                                storyData[currenStoryView][currenSubStory].friend && {
                                    text: Translate('responseStory', 'es'),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        setIsShowResponse(true)
                                    }
                                },
                                !storyData[currenStoryView][currenSubStory].friend && {
                                    text: Translate('deleteStory', 'es'),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        dispatch(deleteStoryHome(storyData[currenStoryView][currenSubStory].id))
                                    }
                                },
                                (storyData[currenStoryView][currenSubStory].archived === false) ? {
                                    text: Translate('archiveStory', 'es'),
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        dispatch(archiveStoryHome(storyData[currenStoryView][currenSubStory].id, "posts"))
                                    }
                                }
                                    :
                                    {
                                        text: Translate('unArchiveStory', 'es'),
                                        onClick: (e) => {
                                            e.stopPropagation();
                                            dispatch(unArchiveStoryHome(storyData[currenStoryView][currenSubStory].id, "posts"))
                                        }
                                    }
                            ]} />
                    </div>

                </div>

                <div className={styles.story_item_content}>
                    {
                        storyData[currenStoryView][currenSubStory].type === "video" && (
                            <video ref={videoRef} preload="auto" autoPlay className="video-post-view" controls>
                                <source src={storyData[currenStoryView][currenSubStory].url}></source>
                            </video>
                        )
                    }

                    {
                        storyData[currenStoryView][currenSubStory].type === "image" && <img width="100%" src={storyData[currenStoryView][currenSubStory].url} />
                    }


                    {
                        isShowResponse && <ChatInput classNameContend={styles.input_chat_story} handleNewUserMessage={handleNewUserMessage} />
                    }
                </div>
            </div>
            <div>
                <NextIcon className="cls-back-next" height="25" width="25" onClick={() => {
                    if (storyData[currenStoryView][currenSubStory + 1]) {
                        setCurrenSubStory(prevState => prevState + 1)
                        // setIsShowResponse(false)

                    }

                }} />
            </div>

            <div className={`${styles.story_item} ${styles.story_item_prev} ${!storyData[currenStoryView][currenSubStory + 1] ? styles.story_item_none : ''}`}>

                {
                    storyData[currenStoryView][currenSubStory + 1] && (
                        <>
                            <div className={styles.story_item_content}>


                                {
                                    storyData[currenStoryView][currenSubStory + 1].type === "video" && <img width="100%" src={storyData[currenStoryView][currenSubStory + 1].urlThumb} />
                                }

                                {
                                    storyData[currenStoryView][currenSubStory + 1].type === "image" && <img width="100%" src={storyData[currenStoryView][currenSubStory + 1].url} />
                                }

                            </div>
                        </>
                    )
                }

            </div>
        </div>
    )
}

export default StoriesBarNew